import { Database, Q } from '@nozbe/watermelondb'

import { ComponentMessageVO } from '@repo/types'
import { Chat, Message } from '../model'

const getMessagesToUpdate = async (messageIds: string[], database: Database) => {
  return database
    .get<Message>('messages')
    .query(Q.where('message_id', Q.oneOf(messageIds)))
    .fetch()
}

export const addMessagesInBatch = async (chat: Chat, payload: ComponentMessageVO[], database: Database) => {
  await database.write(async writer => {
    try {
      const messagesCollection = database.get<Message>('messages')
      const messagesIds = payload.map(it => it.messageId)
      const messagesToUpdate = await getMessagesToUpdate(messagesIds, database)

      const prepareMessages = payload.map(message => {
        const existingMessage = messagesToUpdate.find(it => it.messageId === message.messageId)
        if (!existingMessage)
          return messagesCollection.prepareCreate(_message => _message.setMessageByComponentMessageVO(message, chat))
        else return existingMessage.prepareUpdateMessage(message)
      })

      await writer.batch(...prepareMessages)
    } catch (e) {
      console.error(e)
    }
  })
}
